/**
 * 内部可拖拽
 * @param target 目标元素
 * @param options 配置
 * @param options.start 拖拽开始
 */
export function draggableInner(target, options) {
  function moveFn(e) {
    var _options$drag;
    (_options$drag = options.drag) === null || _options$drag === void 0 ? void 0 : _options$drag.call(options, e);
  }
  function downFn(e) {
    var _options$start;
    document.addEventListener('mousemove', moveFn);
    document.addEventListener('touchmove', moveFn, {
      passive: false
    });
    document.addEventListener('mouseup', upFn);
    document.addEventListener('touchend', upFn);
    (_options$start = options.start) === null || _options$start === void 0 ? void 0 : _options$start.call(options, e);
  }
  function upFn(e) {
    var _options$end;
    document.removeEventListener('mousemove', moveFn);
    document.removeEventListener('touchmove', moveFn);
    document.removeEventListener('mouseup', upFn);
    document.removeEventListener('touchend', upFn);
    (_options$end = options.end) === null || _options$end === void 0 ? void 0 : _options$end.call(options, e);
  }
  target.addEventListener('mousedown', downFn);
  target.addEventListener('touchstart', downFn, {
    passive: false
  });
  target.addEventListener('click', moveFn);
}